import { NoticeType } from '../types/notices';

class NoticeMapper {
    static getNoticeTypeDescription(s?: NoticeType | null) {
        switch (s) {
            case NoticeType.RequiresAgencyConfirmation:
                return 'Requires confirmation';
            case NoticeType.RefusingService:
                return 'Refusing service';
            case NoticeType.CommunicationDifficulty:
                return 'Communication difficulty';
            case NoticeType.BookingProblemOther:
                return 'Booking problem';
            case NoticeType.SameTenantDetails:
                return 'Same tenant details';
            case NoticeType.UnableToContactOccupantAuto:
            case NoticeType.UnableToContactOccupant:
                return 'Unable to contact';
            case NoticeType.TenantRequiresAgencyAttendance:
                return 'Requires agency attendance';
            case NoticeType.NoTenantDetails:
                return 'No tenant details';
            case NoticeType.TenantUnavailableBusinessHours:
                return 'Tenant unavailable';
            case NoticeType.DueDateNotCorrectlyUpdated:
                return 'Due date problem';
            case NoticeType.TenantCancelledConsecutively:
                return 'Tenant cancelled consecutively';
            case NoticeType.RequireUpdateDetailXDays:
                return 'Requires updated details';
            case NoticeType.AccessProblemBadKeys:
                return 'Key issue';
            default:
                return 'Access issues';
        }
    }
}

export { NoticeMapper };
